module.exports = __webpack_public_path__ + "img/5a8b5769560494c3912e6f0e93ef98d5.png";